<div mat-dialog-title style="float: left; width: 100%; padding: 0 0 1em 0">
  <div style="width: 100%; background-color: #002b43; float: left; color: white">
    <div style="width: 90%; float: left">
      <div style="margin: 1em">
        {{ 'fieldNames.sendRequest' | translate }}
      </div>
    </div>
  </div>
</div>
<div mat-dialog-content>
  <h4 style="text-align: center">{{ 'messages.emailRequest' | translate }}</h4>
  <div style="margin: 1em; color: rgb(0, 0, 0); font-size: small">
    <mat-form-field class="emails" appearance="fill">
      <input matInput placeholder="ejemplo@ex.com" [(ngModel)]="emails" />
      @if (this.error) {
        <mat-hint class="error">
          <strong>{{ 'errorMessages.emailsError' | translate }}</strong>
        </mat-hint>
      }
    </mat-form-field>
  </div>
</div>
<div mat-dialog-actions>
  <div style="margin: 0 auto">
    <div style="padding-bottom: 2em">
      <button class="btn btnContinuar" mat-button (click)="sendRequest()">
        {{ 'messages.accept' | translate }}
      </button>
    </div>
  </div>
  <div style="margin: 0 auto">
    <div style="padding-bottom: 2em">
      <button class="btn btn-cancelar" mat-button mat-dialog-close>
        {{ 'labels.close' | translate }}
      </button>
    </div>
  </div>
</div>
